import classes from './App.module.css';
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "./store/auth-Slice";
import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, useNavigate, } from "react-router-dom";
import RootLayout from "./Pages/Root/Root/AuthRootLayout";
import SubRootLayout from './Pages/Root/SubRoot/SubRootLayout';
import SearchView, { loader, loader as SearchViewLoader } from "./Pages/SearchView/SearchView";
import AllSites, { loader as DashboardLoader } from './Pages/AllSites/allSites';
import Dashboard from './Pages/Dashboard/Dashboard'
import SiteView, { loader as siteviewLoader } from "./components/Site/Device/SiteView";
import ErrorPage from "./Pages/Error/ErrorPage";
import VerifyPage from "./components/LoggingIn/VerifyAccount/VerifyPage";
import LoginPage from './components/LoggingIn/LoginV2/LoginPage';
import PortalActivityPage, { loader as portalActivityLoader } from './Pages/PortalActivity/PortalActivityPage';
import UserManagementPage, { loader as userManagementPageLoader } from './Pages/User Management/UserManagementPageTableView';
import { uiActions } from './store/ui-slice';
import UserDevicesPage, { loader as userDevicesPageLoader } from './Pages/User Devices/UserDevicesPage';
import UserManagementRoot from './Pages/User Management/UserManagementRoot';
import RegisterPage from './components/LoggingIn/Register/RegisterPage';
import FullRegistration from './components/UI/Cards/FormCard/FullRegistration';
import Padlocks from './Pages/Padlocks/padlocks';
import Sensors from './Pages/Sensors/sensors';
import Gateways from './Pages/Gateways/gateways'
import Keyboxes from './Pages/Keyboxes/keyboxes';
import OfflineSites from './Pages/OfflineSites/offlineSites';
import Controllers from './Pages/Controllers/Controllers';
import UserManagementPageCardGrid from './Pages/User Management/UserManagementPageCardGrid';
import { tokenLoader, checkAuthLoader } from "./auth";
import { loader as logoutAction } from "./Pages/Logout/Logout";
import DeviceActivityPage, {loader as deviceActivityPageLoader} from './Pages/DeviceActivity/DeviceActivityPage';
import Groups, {loader as groupsLoader} from './Pages/Groups/Groups';
import GroupSites, {loader as GroupSitesLoader} from './Pages/Groups/GroupSites';
import GroupUsers from './Pages/Groups/GroupUsers';
import ResetPin from './ResetPin/resetPin'
import CreatePin from './CreatePin/createPin';
import ResetSuccess from './ResetPin/resetSuccess'
import CreateSuccess from './CreatePin/createSuccess';
import CreateAccount from './Register/register'
import RegisterSuccess from './Register/registerSuccess'
import FullAccountRegistration from './Register/fullAccountRegistration'
import { socket } from './Socket/socket';
import DataManager from './hooks/DataManager';
import { elements } from 'chart.js';
import UpdateBanner from './VersionControl/UpdateBanner';
import ResetPortalPassword from './components/LoggingIn/ResetPassword/ResetPortalPassword';
import PortalPasswordResetSuccess from './components/LoggingIn/ResetPassword/PortalPasswordResetSuccess';
import RuleReducer, { RuleProvider } from './components/UI/Cards/Automations/CreateRuleNew/RuleReducer'
import InactiveSites from './Pages/InactiveSites/inactiveSites';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import SitesOnSchedule from './Pages/SitesOnSchedule/sitesOnSchedule';
import ActiveSites from './Pages/ActiveSites/activeSites';
import CCTVIntegrations from './Pages/CCTVIntegrations/CCTVIntegrations';
import PadlockEntity, { padlockLoader } from './Pages/Padlocks/padlockEntity';
import ScheduledAction from './components/UI/Cards/Automations/EditAutomations/ScheduledAction';
import ScheduledActionsSites from './Pages/HolidayMode/scheduledActions';
import LiveViewSites from './Pages/LiveViewSites/liveViewSites';
import SiteCameras, { camerasLoader } from './Pages/LiveViewSites/siteCameras';
import autoLogout from './hooks/autoLogout';
import useAutoLogout from './hooks/autoLogout';
import mixpanel from 'mixpanel-browser';


const dataManager = new DataManager();

const AuthRoute = {

  path: '/',
  element: <RootLayout/>,
  errorElement: <ErrorPage/>,
  loader: tokenLoader,
  children: [
    {
      index: true,
      element: <LoginPage/>
    },
    {
      path: 'Verify',
      element: <VerifyPage/>,
      loader: checkAuthLoader,
    },
    {
      path: 'Register',
      element: <RegisterPage />
    },
    {
      path: 'FullRegistration',
      element: <FullRegistration />
    },
    {
      path: '/Dashboard',  // <-- changed from /AllSites
      element: <SubRootLayout />,
      loader: checkAuthLoader,
      children: [
        {
          index: true,
          element: <Dashboard />  // <-- now the default landing page
        },
        {
          path: 'AllSites',
          element: <AllSites />,
          loader: DashboardLoader
        },
        {
          path: 'SearchView',
          element: <SearchView />,
          loader: SearchViewLoader
        },
        {
          path: 'SiteView/:SiteID',
          element: <SiteView />,
          loader: siteviewLoader
        },
        {
          path: 'Users',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <UserManagementPageCardGrid />,
              loader: userManagementPageLoader
            },
            {
              path: 'UserSites',
              element: <UserDevicesPage />,
              loader: userDevicesPageLoader
            },
          ]
        },
        {
          path: 'Offline',
          element: <OfflineSites/>
        },
        {
          path: 'TemporarySchedules',
          element: <SitesOnSchedule/>
        },
        {
          path: 'ScheduledActions',
          element: <ScheduledActionsSites/>
        },
        {
          path: 'Controllers',
          element: <Controllers/>
        },
        {
          path: 'ActiveSites',
          element: <ActiveSites/>
        },
        {
          path: 'InactiveSites',
          element: <InactiveSites/>
        },
        {
          path: 'CCTVIntegrations',
          element: <CCTVIntegrations/>
        },
        

        {
          path: 'LiveViewSites',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <LiveViewSites />
            },
            {
              path: 'Site/:SiteUUID',
              element: <SiteCameras/>,
              loader: camerasLoader
            }
          ]
        },

        {
          path: 'Activity',
          element: <PortalActivityPage />,
          loader: portalActivityLoader
        },
        {
          path: 'SiteActivity',
          element: <DeviceActivityPage />,
          loader: deviceActivityPageLoader
        },
        {
          path: 'Groups',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <Groups />,
              loader: groupsLoader,
            },
            {
              path: 'GroupSites',
              element: <GroupSites />,
              children: [
                {
                  path: 'GroupUsers',
                  element: <GroupUsers />,
                },
              ],
            },
          ],
        },
        {
          path: 'Padlocks',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <Padlocks />
            },
            {
              path: 'Lock/:LockID',
              element: <PadlockEntity/>,
              loader: padlockLoader
            }
          ]
        },
        {
          path: 'Keyboxes',
          element: <Keyboxes />
        },
        {
          path: 'Sensors',
          element: <Sensors />
        },
        {
          path: 'Gateways',
          element: <Gateways />
        },
        
      ]
    },
    {
      path: '/logout',
      loader: logoutAction
    },
    {
      path: "/ResetPin",
      element: <ResetPin />,
    },
    {
      path: "/ResetSuccess",
      element: <ResetSuccess />,
    },
     {
      path: "/CreatePin",
      element: <CreatePin />,
    },
    {
      path: "/CreateSuccess",
      element: <CreateSuccess />,
    },
    {
      path: "/CreateAccount",
      element: <CreateAccount />,
    },
    {
      path: "/RegisterSuccess",
      element: <RegisterSuccess />,
    },
    {
      path: "/CreateAdminAccount",
      element: <FullAccountRegistration />,
    },
    {
      path: "/resetPortalPassword", 
      element: <ResetPortalPassword/>
    },
    {
      path: "/resetPortalPasswordSuccess",
      element: <PortalPasswordResetSuccess/>
    }
  ],
}

const router = createBrowserRouter([
  AuthRoute
]);

const App = (props) => {
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [pinStates, setPinStates] = useState([]);
  const [versionNumber, setVersionNumber] = useState(sessionStorage.getItem('versionNumber') || "1.0.0")
  const [visible, setVisible] = useState(false)

  console.log(versionNumber)
  sessionStorage.setItem('versionNumber', versionNumber)


//   useAutoLogout({
//   timeout: 10 * 60 * 1000,
//   onLogout: () => {
//     localStorage.clear();
//     window.location.href = '/logout'; // full page redirect
//   },
// });

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    function onPinStatesChange(value) {
      if (dataManager.getItem('deviceUUIDs').includes(value['uuid'])){
        setPinStates(value);
      }
    }

    function onPortalVersionChange(newVersion) {
      setVersionNumber(newVersion)
      const oldNumber = sessionStorage.getItem('versionNumber')
      if (oldNumber !== newVersion){
          setVisible(true)
          sessionStorage.setItem('versionNumber', newVersion)
      }
    }

    mixpanel.init('9efe9e0b92c0da315253d30b290c81b5', {
      autocapture: false,
      record_sessions_percent: 100,
      api_host: 'https://api-eu.mixpanel.com',
    })

    // const handleBeforeUnload = (e) => {
    //   // If you want to trigger only when user is logged in:
    //   const token = localStorage.getItem("token");
    //   if (!token) return;

    //   e.preventDefault();
    //   e.returnValue = ""; // Required for Chrome
    // };

    //window.addEventListener("beforeunload", handleBeforeUnload);

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('appPinStates', onPinStatesChange);
    socket.on('portalVersionNumber', onPortalVersionChange);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('appPinStates', onPinStatesChange);
      socket.off('portalVersionNumber', onPortalVersionChange);

      // window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  const token = useSelector(state => state.auth.token);
  const refreshToken = useSelector(state => state.auth.refreshToken);
  const dispatch = useDispatch();

  return (
    <React.Fragment>
      <UpdateBanner visible={visible} setVisible={setVisible}/>

      {/* Wrap RouterProvider with RuleProvider */}
      <PrimeReactProvider>

      
      <RuleProvider>
        <RouterProvider router={router} />
      </RuleProvider>
      </PrimeReactProvider>
    </React.Fragment>
  );
}

export default App;


